import * as React from "react";
import { useState } from "react";
import { Grid } from "@material-ui/core";
import { useDataProvider, useNotify, useRefresh, Button, Toolbar } from "react-admin";
import { Form } from "react-final-form";
import { useAppDataProvider } from "../../../dataprovider";
import { CoreInfoRequestReasonTypeEnum } from "../../../Enums/CoreInfoRequestReasonTypeEnum";
import { CoreInfoRequestReasonType } from "../../../Constants/Constant";
import { CoreInfoRequestPutModel } from "../Model/CoreInfoRequestModel";
import { CoreInfoRequestStatusEnum } from "../../../Enums/CoreInfoRequestStatusEnum";
import { useLoading } from "../../../Components/Loading/useLoading";
import { useCoreInfoRequestStyles } from "./utils/styles";
import { Confirm } from "react-admin";
import { Update } from "@material-ui/icons";
import { CircularProgress, Card, CardContent } from "@material-ui/core";

// Import components
import CoreInfoRequestHeader from "./components/CoreInfoRequestHeader";
import BasicInformationCard from "./components/BasicInformationCard";
import TechnicalDataCard from "./components/TechnicalDataCard";
import AdditionalDetailsCard from "./components/AdditionalDetailsCard";
import AttachmentsCard from "./components/AttachmentsCard";
import CoreInfoHistoryAccordion from "./components/CoreInfoHistoryAccordion";
import PbhHistoryAccordion from "./components/PbhHistoryAccordion";

const CustomerCoreInfoRequestEdit = props => {
  const dataProvider = useAppDataProvider();
  const provider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { showLoading, hideLoading } = useLoading();
  const classes = useCoreInfoRequestStyles();

  // State management
  const [selectedReasons, setSelectedReasons] = useState<Number[]>([]);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const submitRef = React.useRef<(() => void) | null>(null);
  const [tsi, setIsTsi] = useState(true);
  const [tso, setIsTso] = useState(true);
  const [tsr, setIsTsr] = useState(true);
  const [tsn, setIsTsn] = useState(true);
  const [csi, setIsCsi] = useState(true);
  const [cso, setIsCso] = useState(true);
  const [csr, setIsCsr] = useState(true);
  const [csn, setIsCsn] = useState(true);
  const [dsi, setIsDsi] = useState(true);
  const [dso, setIsDso] = useState(true);
  const [dsr, setIsDsr] = useState(true);
  const [dsn, setIsDsn] = useState(true);
  const [removalReasonDetail, setIsRemovalReasonDetail] = useState(true);
  const [dom, setIsDom] = useState(true);
  const [adSbMod, setIsAdSbMod] = useState(true);
  const [nha, setIsNha] = useState(true);
  const [nla, setIsNla] = useState(true);
  const [engineSerialNumber, setIsEngineSerialNumber] = useState(true);
  const [isFileTypeSelected, setIsFileTypeSelected] = useState(false);
  const [selectedCoreInfoRequestFileType, setSelectedCoreInfoRequestFileType] = useState(0 as number);
  const [getFileGrid, setValueFileGrid] = useState({} as boolean);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [requestHistoryData, setRequestHistoryData] = useState<any[]>([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [pbhHistoryData, setPbhHistoryData] = useState<any[]>([]);
  const [pbhHistoryLoading, setPbhHistoryLoading] = useState(false);
  const validate = [];

  // Fetch selected reasons
  React.useEffect(() => {
    provider
      .getList("coreinforequestdetails", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: { coreInfoRequestId__eq: props.id },
      })
      .then(response => {
        var selectedReason: number[] = [];

        if (response.data.length > 0) {
          response.data.forEach(element => {
            selectedReason.push(element.coreInfoRequestReasonId);
          });

          setSelectedReasons(selectedReason);
          setIsTsi(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Tsi));
          setIsTso(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Tso));
          setIsTsr(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Tsr));
          setIsTsn(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Tsn));
          setIsCsi(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Csi));
          setIsCso(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Cso));
          setIsCsr(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Csr));
          setIsCsn(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Csn));
          setIsDso(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Dso));
          setIsDsi(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Dsi));
          setIsDsr(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Dsr));
          setIsDsn(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Dsn));
          setIsDom(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Dom));
          setIsNha(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Nha));
          setIsNla(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.Nla));
          setIsEngineSerialNumber(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.EngineSerialNumber));
          setIsAdSbMod(!selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.AdSbMod));
          setIsRemovalReasonDetail(
            !selectedReason.some(t => t === CoreInfoRequestReasonTypeEnum.DetailedRemovalReason)
          );
        }
      })
      .catch(error => {
        console.error("Error fetching reasons:", error);
      });
  }, [props.id]);

  // Fetch Core Info Request History
  React.useEffect(() => {
    setHistoryLoading(true);
    dataProvider
      .getCoreInfoRequestHistoryList(props.id)
      .then(response => {
        setRequestHistoryData(response.data.items || []);
      })
      .catch(error => {
        console.error("Error fetching history:", error);
        notify("Error loading history data", "error");
      })
      .finally(() => {
        setHistoryLoading(false);
      });
  }, [props.id]);

  // Fetch PBH Unserviceable History
  React.useEffect(() => {
    setPbhHistoryLoading(true);
    dataProvider
      .getPbhUnserviceableRequestHistoryList(props.id)
      .then(response => {
        console.log("PBH History:", response);
        setPbhHistoryData(response.data.items || []);
      })
      .catch(error => {
        console.error("Error fetching PBH history:", error);
        notify("Error loading PBH history data", "error");
      })
      .finally(() => {
        setPbhHistoryLoading(false);
      });
  }, [props.id]);

  // Update handler
  const updateCoreInfoRequest = async (e: any) => {
    showLoading();

    // check for required files if any file type is selected as reason
    const fileTypeReasons = CoreInfoRequestReasonType.filter(
      r => r.isFileType && selectedReasons.some(s => Number(s) === r.value)
    );
    const missingFiles = fileTypeReasons.filter(
      r => !uploadedFiles.some(f => Number(f.coreInfoRequestFileType) === r.value)
    );
    if (missingFiles.length > 0) {
      const missing = missingFiles.map(r => r.reasonType).join(", ");
      hideLoading();
      notify(`Please upload required file(s) for: ${missing}`, "error");
      return;
    }

    let coreInfoRequestModel: CoreInfoRequestPutModel = new CoreInfoRequestPutModel();
    coreInfoRequestModel.Id = props.id;
    coreInfoRequestModel.RequestId = props.record.requestId;
    coreInfoRequestModel.Remark = props.record.remark;
    coreInfoRequestModel.RequestedFields = props.record.requestedFields;
    coreInfoRequestModel.Tsi = e.tsi;
    coreInfoRequestModel.Csi = e.csi;
    coreInfoRequestModel.Dsi = e.dsi;
    coreInfoRequestModel.Tso = e.tso;
    coreInfoRequestModel.Cso = e.cso;
    coreInfoRequestModel.Dso = e.dso;
    coreInfoRequestModel.Tsr = e.tsr;
    coreInfoRequestModel.Csr = e.csr;
    coreInfoRequestModel.Dsr = e.dsr;
    coreInfoRequestModel.Tsn = e.tsn;
    coreInfoRequestModel.Csn = e.csn;
    coreInfoRequestModel.Dsn = e.dsn;
    coreInfoRequestModel.RemovalReasonDetail = e.removalReasonDetail;
    coreInfoRequestModel.Dom = e.dom;
    coreInfoRequestModel.AdSbMod = e.adSbMod;
    coreInfoRequestModel.Nha = e.nha;
    coreInfoRequestModel.Nla = e.nla;
    coreInfoRequestModel.EngineSerialNumber = e.engineSerialNumber;
    coreInfoRequestModel.IsCustomerUpdate = true;

    // Auto-update status to Responded when customer updates from WaitingCustomer status
    // This handles the case where customers forget to use "Send to TT" button
    // When status is WaitingCustomer, updating automatically changes it to Responded
    if (props.record.status === CoreInfoRequestStatusEnum.WaitingCustomer) {
      coreInfoRequestModel.Status = CoreInfoRequestStatusEnum.Responded;
      coreInfoRequestModel.RespondedDate = new Date();
      coreInfoRequestModel.IsStatusUpdate = true;
    } else {
      coreInfoRequestModel.Status = props.record.status;
      coreInfoRequestModel.IsStatusUpdate = false;
    }

    dataProvider
      .putCoreInfoRequest(coreInfoRequestModel)
      .then(() => {
        notify(`Record updated successfully`, "success", false, true);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => {
        setLoading(false);
        hideLoading();
      });
  };

  // Confirmation handlers
  const handleConfirmUpdate = () => {
    if (submitRef.current) {
      submitRef.current();
    }
    setConfirmOpen(false);
  };

  const handleCancelUpdate = () => {
    setConfirmOpen(false);
  };

  // File handlers
  const changeCoreInfoRequestFileType = value => {
    if (selectedReasons.some(t => t === value.target.value)) {
      setIsFileTypeSelected(true);
      setSelectedCoreInfoRequestFileType(value.target.value);
    } else {
      setIsFileTypeSelected(false);
      setSelectedCoreInfoRequestFileType(value.target.value);
      notify(`Please Select Related File Type`);
    }
  };

  const onHandleFileExecute = async () => {
    setValueFileGrid(true);
  };

  const onFileGridRefresh = async () => {
    setValueFileGrid(false);
  };

  return (
    <Form
      onSubmit={updateCoreInfoRequest}
      initialValues={{ ...props.record, coreInfoRequestReasons: selectedReasons }}
      validate={values => ({})}
      render={({ handleSubmit }) => {
        submitRef.current = () => { handleSubmit(); };
        return (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CoreInfoRequestHeader record={props.record} classes={classes} />

                <BasicInformationCard
                  record={props.record}
                  selectedReasons={selectedReasons}
                  classes={classes}
                  disabled={true}
                />

                <TechnicalDataCard
                  record={props.record}
                  classes={classes}
                  mode="customer"
                  tsi={tsi}
                  csi={csi}
                  dsi={dsi}
                  tso={tso}
                  tsr={tsr}
                  tsn={tsn}
                  cso={cso}
                  csr={csr}
                  csn={csn}
                  dso={dso}
                  dsr={dsr}
                  dsn={dsn}
                  validate={validate}
                />

                <AdditionalDetailsCard
                  record={props.record}
                  classes={classes}
                  mode="customer"
                  dom={dom}
                  removalReasonDetail={removalReasonDetail}
                  nha={nha}
                  nla={nla}
                  engineSerialNumber={engineSerialNumber}
                  adSbMod={adSbMod}
                  validate={validate}
                />

                <AttachmentsCard
                  classes={classes}
                  canEdit={props.record.status !== CoreInfoRequestStatusEnum.Accepted}
                  changeRequestOrderFileType={changeCoreInfoRequestFileType}
                  selectedCoreInfoRequestFileType={selectedCoreInfoRequestFileType}
                  onHandleFileExecute={onHandleFileExecute}
                  onFileGridRefresh={onFileGridRefresh}
                  getFileGrid={getFileGrid}
                  coreInfoRequestId={props.id}
                  isFileTypeSelected={isFileTypeSelected}
                  onFilesChange={setUploadedFiles}
                  selectedReasons={selectedReasons}
                  uploadedFiles={uploadedFiles}
                />

                <CoreInfoHistoryAccordion
                  classes={classes}
                  historyLoading={historyLoading}
                  requestHistoryData={requestHistoryData}
                />

                <PbhHistoryAccordion
                  classes={classes}
                  pbhHistoryLoading={pbhHistoryLoading}
                  pbhHistoryData={pbhHistoryData}
                />

                {props.record.status !== CoreInfoRequestStatusEnum.Accepted && (
                  <Card className={classes.card}>
                    <CardContent>
                      <Toolbar placeholder="" classes={classes}>
                        <Button
                          label={loading ? "Core Info Request is updating!" : "Update Core Info Request"}
                          disabled={loading}
                          size="medium"
                          variant="contained"
                          onClick={() => setConfirmOpen(true)}
                          style={{
                            margin: "8px",
                            background: "#ffc107 !important",
                          }}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                        </Button>
                      </Toolbar>
                    </CardContent>
                  </Card>
                )}

                <Confirm
                  isOpen={confirmOpen}
                  loading={loading}
                  title="Confirm Update"
                  content={
                    props.record.status === CoreInfoRequestStatusEnum.WaitingCustomer
                      ? 'The status will change to "responded". Do you approve?'
                      : "Do you want to update?"
                  }
                  confirm="Yes"
                  cancel="No"
                  onConfirm={handleConfirmUpdate}
                  onClose={handleCancelUpdate}
                />
              </Grid>
            </Grid>
          </form>
        );
      }}
    />
  );
};

export default CustomerCoreInfoRequestEdit;
